import { Paper, Skeleton, Stack } from "@mui/material";
import { Grid } from "@mui/system";

/** Placeholder that mirrors ViewReportModal's body while the detail loads. */
const ViewReportSkeleton = () => (
  <Stack spacing={2.5}>
    <Skeleton width={70} height={16} />
    <Skeleton variant="rounded" height={40} />

    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Skeleton variant="rounded" height={40} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Skeleton variant="rounded" height={40} />
      </Grid>
    </Grid>

    <Skeleton variant="rounded" height={40} />

    <Paper variant="outlined">
      <Skeleton
        variant="rectangular"
        height={44}
        sx={{ borderBottom: "1px solid #0000001F" }}
      />
      <Stack direction="row">
        {[0, 1].map((column) => (
          <Stack
            key={column}
            spacing={1.5}
            sx={{
              flex: 1,
              p: 1.5,
              borderRight: column === 0 ? "1px solid #0000001F" : undefined,
            }}
          >
            <Skeleton height={20} />
            {[0, 1, 2].map((row) => (
              <Skeleton key={row} variant="rounded" height={34} />
            ))}
          </Stack>
        ))}
      </Stack>
    </Paper>
  </Stack>
);

export default ViewReportSkeleton;
